
import Testimonials from './Testimonials'
import UsageStats from './UsageStats'
import CustomerLogoCarousel from './CustomerLogoCarousel'

const SocialProof = () => {
  const stats = [
    { value: 10, suffix: 'M+', label: 'People Engaged' },
    { value: 500, suffix: '+', label: 'Campaigns Launched' },
    { value: 98, suffix: '%', label: 'Satisfaction Rate' }
  ]

  const testimonials = [
    {
      quote: "Activate America has a large postcarding operation with thousands of volunteers, with over 9 million postcards written for the 2024 election cycle. Moving to Sincere for our postcard campaign distribution is allowing us to provide top notch service to our volunteers, easily track our numbers, and rapidly expand our program. And the customer service provided by Sincere is unparalleled - our staff and volunteers are amazed by how quickly we get responses to every question.",
      author: "Anna Martin",
      role: "Postcard Program Director, Activate America",
      avatar: "/images/customer-quote-avatars/anna-martin.jpg"
    },
    {
      quote:
        'Sincere has been a dream come true! It\'s been an ideal platform for VoteRiders to dramatically expand our letter-writing activities, and it\'s been a breeze to use for our staff and volunteers alike.',
      author: 'Lauren Kunis,',
      role: 'Executive Director, VoteRiders',
      avatar: "/images/customer-quote-avatars/lauren-kunis.jpg"
  },
  ]

  // Partner logos
  const partnerLogos = [
    { name: 'VoteRiders', src: '/images/customer-logos/voteriders.png' },
    { name: 'CFCG', src: '/images/customer-logos/cfcg.png' },
    { name: '43rd Dems', src: '/images/customer-logos/43rddems.png' },
    { name: 'Activate America', src: '/images/customer-logos/activateamerica.png' },
    { name: 'Seattle Indivisible', src: '/images/customer-logos/seattle-indivisible.png' }
  ]

  return (
    <section
      id="sincere"
      className="social-proof-section bg-white"
    >
      <div className="container flex flex-col gap-20 pt-20">
          <UsageStats stats={stats} />
          <Testimonials testimonials={testimonials} />
          <CustomerLogoCarousel partnerLogos={partnerLogos} />
      </div>
    </section>
  )
}

export default SocialProof
